<div class="row">
    <div class="col-12">
        <div id="clientList" class="card mb-0">
            <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="clientListService"
                [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (resetListLayout) = "clientListService.resetListState($event)"
                (searchTermChanged)="clientListService.searchTerm = $event"
                (paginationSelected)="paginationUpdated(clientListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="clientListService.pageSize = $event"></app-list-layout>
            <div class="p-3 gap-2 d-flex justify-content-end" style="padding-top: 0 !important;">
                <button [disabled]="submitted || isLoadingVal" class="btn btn-primary " (click)="uncheckAll(listItems)">
                    <div style="display: inline-flex; ">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div style="text-align: center;" i18n="@@">Clear</div>
                    </div>
                </button>
                <button [disabled]="submitted || isLoadingVal" class="btn btn-success" (click)="selectClients()">
                    <div style="display: inline-flex; ">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div style="text-align: center;" i18n="@@">Select</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>